import { render, staticRenderFns } from "./reservation-petit-gite.vue?vue&type=template&id=6a5ad45c&scoped=true&"
import script from "./reservation-petit-gite.vue?vue&type=script&lang=js&"
export * from "./reservation-petit-gite.vue?vue&type=script&lang=js&"
import style0 from "./reservation-petit-gite.vue?vue&type=style&index=0&id=6a5ad45c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ad45c",
  null
  
)

export default component.exports